/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const ON_NOTIFY_KCHAT_MESSAGE_UPDATE = gql`
  subscription OnNotifyKChatMessageUpdate($workerId: ID!, $departmentId: ID!) {
    onNotifyKChatMessageUpdate(
      workerId: $workerId
      departmentId: $departmentId
    ) {
      id
      departmentId
      workerId
      message
      timestamp
      displayName
      role
    }
  }
`;
